export function shouldShowVerifiedArtistCheckmark(params: {
  readonly authorRole: string
  readonly artistId?: string | null
  readonly liveArtistIds: ReadonlySet<string>
}): boolean {
  if (params.authorRole !== 'artist') {
    return false
  }
  const artistId = params.artistId?.trim()
  if (!artistId) {
    return false
  }
  return params.liveArtistIds.has(artistId)
}
